import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import { Product } from 'src/components/ProductDetail/utils/product-detail.types';
import { ProductAttrs } from 'src/components/ProductDetail/utils/product-attrs.types';
import { ClickAndCollect, HomeDelivery } from 'src/components/ProductDeliveryOption';
import { ProductStockModalProps } from 'src/components/StoreLocator/ProductStockModal';

import { paths } from '../../config.json';

type DeliveryOptionsProps = {
    attrs: ProductAttrs;
    isComingSoon?: boolean;
    product: Product;
};

export function DeliveryOptions(props: DeliveryOptionsProps) {
    const [showModal, toggleModal] = useState(false);

    return (
        <>
            {showModal && (
                <React.Suspense fallback={null}>
                    <LazyProductStockModal
                        productIds={[Number(props.product.id)]}
                        onDismiss={() => toggleModal((x) => !x)}
                    />
                </React.Suspense>
            )}

            <ClickAndCollect isAvailable={props.attrs.click_collect} pageType="productDetail">
                <button onClick={() => toggleModal(true)} type="button">
                    Check store availability
                </button>
            </ClickAndCollect>

            <HomeDelivery isAvailable={props.attrs.delivery} pageType="productDetail">
                <Link to={paths.cms.deliveryInformation}>Delivery Information</Link>
            </HomeDelivery>
        </>
    );
}

const LazyProductStockModal: React.FC<ProductStockModalProps> = React.lazy(
    () => import('../StoreLocator/ProductStockModal'),
);
